import { UserType } from '@gopeerproject/chuck';
import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Text } from '../../Text';
import { User } from '../../User';
import { IconButton } from '../../IconButton';
export function Regular({ name, fluid, image, subject, onCheckoutProfile, onContact, style }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, fluid ? styles.fluid : {}, style] },
        React.createElement(User, { size: 'md', image: image, name: name, type: UserType.TUTOR }),
        React.createElement(View, { style: styles.main },
            React.createElement(Text, { type: 'headline', size: 'lg', style: styles.name, numberOfLines: 1 }, name),
            React.createElement(Text, { style: styles.subject, numberOfLines: 1, type: 'body', size: 'md', weight: 'regular' }, subject)),
        React.createElement(View, { style: styles.actions },
            React.createElement(IconButton, { value: 'person', type: 'secondary', accent: 'default', onPress: onCheckoutProfile, style: styles.action__withMargin, size: 'sm' }),
            React.createElement(IconButton, { value: 'chat', type: 'secondary', accent: 'default', onPress: onContact, size: 'sm' }))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        backgroundColor: color.invert2.p4,
        padding: size.G,
        borderRadius: size.G,
        alignItems: 'center',
        justifyContent: 'center'
    },
    fluid: { flex: 1 },
    name: {},
    main: {
        marginTop: size.C,
        width: 110,
        alignItems: 'center'
    },
    subject: {
        color: color.invert2.p56,
        marginTop: size.A
    },
    actions: {
        marginTop: size.G,
        flexDirection: 'row'
    },
    action__withMargin: {
        marginRight: size.C
    }
}));
//# sourceMappingURL=Regular.js.map